import React from 'react'

export default function AutoCall() {
  return (
    <div>AutoCall</div>
  )
}
